const defaultOptions = {
  classes: {
    disabled: 'is-disabled'
  },
  selectors: {
    formElement: '[data-subscribe-form]',
    submitButton: 'button[type="submit"]',
    htmlBodyField: 'input[name="html_body"]'
  }
};

export default class EmailForm {
  static init(options) {
    let emailForm = new EmailForm(options);
    return emailForm;
  }

  constructor(options) {
    this.options = Object.assign(options, defaultOptions, options);
    this.form =
      document.querySelector(this.options.selectors.formElement) || null;
    if (this.form === null) {
      return;
    }

    this.configureListeners();
  }

  configureListeners() {
    this.form.addEventListener('submit', (e) => {
      if (this.form.dataset.submitted) {
        e.preventDefault();
        return;
      }
      this.form.dataset.submitted = 'true';
      this.form.querySelector(
        this.options.selectors.htmlBodyField
      ).value = this.htmlBody();
      this.form
        .querySelector(this.options.selectors.submitButton)
        .classList.add(this.options.classes.disabled);
    });
  }

  htmlBody() {
    let htmlBody = '';
    let inputArray = Array.from(
      this.form.querySelectorAll('input:not([type=hidden]):not([type=submit])')
    );
    let selectArray = Array.from(this.form.querySelectorAll('select'));
    selectArray.forEach((element) => {
      if (element.selectedIndex) {
        inputArray.push(element[element.selectedIndex]);
      }
    });
    inputArray = inputArray.concat(
      Array.from(
        this.form.querySelectorAll('textarea:not([name="g-recaptcha-response"])')
      )
    );
    inputArray.forEach((element) => {
      if (!(element.getAttribute('type') === 'checkbox' && !element.checked)) {
        const label = this.formatFieldLabel(
          element.getAttribute('name').replace(/\[\]/, '')
        );
        htmlBody += `<strong>${label}</strong>: ${element.value}<br>`;
      }
    });
    return htmlBody;
  }

  formatFieldLabel(name) {
    const spaced = name.replaceAll('_', ' ');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }
}

EmailForm.init({});
